const MAC = 'Mac'
// Office.js PlatformType for Windows desktop (window.Office.context.platform)
const PC = 'PC'

export default {
  MAC,
  PC,
}
